import { getConfidenceInterval } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/errData'

// `useHTML: true` tooltips get no SVG box, so the surface is drawn in CSS instead —
// see styles/highcharts.scss. Every useHTML formatter routes its markup through here.
// A formatter returning `false` suppresses the tooltip entirely and must pass through.
export const wrapTooltip = content => (false === content || null == content ? content : `<div>${content}</div>`)

export const createTooltipFormatter = (options = {}) => {
  const {
    format = {},
    qType,
    viewMode,
    answerType,
    ignorePercents,
    axisType,
    confidenceLevel,
    reportPercentDecimals
  } = options

  return function () {
    const _t = this.point

    if (_t.name === '' || _t.y === 0) return false

    const mergedFormat = Object.assign({ showErrors: true, showSignificance: true }, format)
    const percentDecimals = Object.hasOwn(mergedFormat, 'percentDecimals')
      ? mergedFormat.percentDecimals
      : (reportPercentDecimals ?? 1)

    let err = ''
    if (mergedFormat.showErrors && _t?.errData?.err != null) {
      const ci = getConfidenceInterval(_t, percentDecimals, {
        qType,
        viewMode,
        answerType,
        ignorePercents,
        confidenceLevel,
        axisType
      })
      if (ci) err = `&nbsp;(${ci})`
    }

    return wrapTooltip(_t.name.replace('{err}', err))
  }
}
